import { useEffect } from "react";

export default function useFavicon(faviconUrl?: string) {
  return useEffect(() => {
    if (!faviconUrl) {
      return;
    }

    let linkElement = document.querySelector(
      "link[rel~='icon']"
    ) as HTMLLinkElement | null;

    if (!linkElement) {
      linkElement = document.createElement("link");
      linkElement.rel = "icon";
      document.head.appendChild(linkElement);
    }

    linkElement.href = faviconUrl;
  }, [faviconUrl]);
}
